import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"

export const getInventarioHilazaMensual = async () => {
   return await PrivateInterceptor('Produccion/BH/InventarioHilazaMensual', 'GET');
}

export const ingresosHilaza = async (dates) => {
   return await PrivateInterceptor('Produccion/BH/ingresosHilaza', 'POST', dates);
}

export const salidasHilaza = async (dates) => {
   return await PrivateInterceptor('Produccion/BH/salidasHilaza', 'POST', dates);
}